export const SET_SEARCH_CONFIG = 'SET_SEARCH_CONFIG';
export const SET_OUT_SIDE_FIELDS = 'SET_OUT_SIDE_FIELDS';
export const SET_HIDDEN_OUT_FIELDS = 'SET_HIDDEN_OUT_FIELDS';
export const INITIAL_CONDITION = 'INITIAL_CONDITION';
export const SEARCH_RESET_MUTATION = 'SEARCH_RESET_MUTATION';
export const RESET_MOBILE_CONDITION = 'RESET_MOBILE_CONDITION';
export const SEARCH_QUERY_ON_URL = 'SEARCH_QUERY_ON_URL';
export const LOCATION_QUERY_ON_URL = 'LOCATION_QUERY_ON_URL';
export const URL_PRESET_PARAMS = 'URL_PRESET_PARAMS';
export const MAP_CONDITION_ON_URL = 'MAP_CONDITION_ON_URL';
export const SET_CUSTOMIZED_CITY = 'SET_CUSTOMIZED_CITY';
export const SET_SEARCH_CHARTS = 'SET_SEARCH_CHARTS';
export const SET_LISTING_SOURCE = 'SET_LISTING_SOURCE';
export const SET_LISTING_IDS = 'SET_LISTING_IDS';
export const SET_LOCATION_PLACEHOLDER = 'SET_LOCATION_PLACEHOLDER';
//  Middle platform 
export const CENTER_SET_SEARCH_CONFIG_MAP = 'CENTER_SET_SEARCH_CONFIG_MAP';
export const CENTER_SET_UI_CONFIG = 'CENTER_SET_UI_CONFIG';
export const CENTER_COMPUTED_PRESET_FILTER = 'CENTER_COMPUTED_PRESET_FILTER';
export const CENTER_UPDATE_CONDITION = 'CENTER_UPDATE_CONDITION';
export const CENTER_RESET_CONDITION = 'CENTER_RESET_CONDITION';
export const CENTER_COMMIT_CONDITION = 'CENTER_COMMIT_CONDITION';
export const CENTER_UPDATE_KEYWORD_CONDITION =
    'CENTER_UPDATE_KEYWORD_CONDITION';
export const CENTER_UPDATE_DEFAULT_CONDITION =
    'CENTER_UPDATE_DEFAULT_CONDITION';
export const CENTER_UPDATE_INPUT_BOX_CONDITION =
    'CENTER_UPDATE_INPUT_BOX_CONDITION';
export const CENTER_UPDATE_ARRAY_CONDITION = 'CENTER_UPDATE_ARRAY_CONDITION';
export const CENTER_UPDATE_UI_CONFIG_ITEM = 'CENTER_UPDATE_UI_CONFIG_ITEM';
export const CENTER_DEL_SUGGESTION = 'CENTER_DEL_SUGGESTION';
export const CENTER_DEL_SELECT = 'CENTER_DEL_SELECT';
export const CENTER_SET_SWITCH = 'CENTER_SET_SWITCH';
export const CLEAR_ALL_CONDITION = 'CLEAR_ALL_CONDITION';
export const CLEAR_CONDITION = 'CLEAR_CONDITION';
export const CENTER_URL_PRESET_PARAMS = 'CENTER_URL_PRESET_PARAMS';
export const CENTER_CONDITION_ON_URL = 'CENTER_CONDITION_ON_URL';
export const RESET_KEY_WORDS = 'RESET_KEY_WORDS';
export const CURRENCY_PRICE_KEYS = 'CURRENCY_PRICE_KEYS';
export const SET_TRANSLATED_PROPS = 'SET_TRANSLATED_PROPS';
export const UPDATE_RAWCONF_OPTIONS = 'UPDATE_RAWCONF_OPTIONS';

export const GRID_OR_LIST_TYPE_MUTATION = 'GRID_OR_LIST_TYPE_MUTATION';
export const SET_PRIMARY_KEYS_MAP = 'SET_PRIMARY_KEYS_MAP';
export const SET_AI_RECOMMEND_LOADING = 'SET_AI_RECOMMEND_LOADING';

